import { render, staticRenderFns } from "./medicine_analysis.vue?vue&type=template&id=64afb79d&scoped=true"
import script from "./medicine_analysis.vue?vue&type=script&lang=js"
export * from "./medicine_analysis.vue?vue&type=script&lang=js"
import style0 from "./medicine_analysis.vue?vue&type=style&index=0&id=64afb79d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64afb79d",
  null
  
)

export default component.exports